import { ChangeDetectionStrategy, Component, output } from '@angular/core';

export type BriefFlow = 'ai' | 'wizard';

/** Landing screen: choose the Noodle AI-first flow or the guided wizard. */
@Component({
  selector: 'bb-flow-chooser',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './flow-chooser.html',
})
export class FlowChooser {
  readonly choose = output<BriefFlow>();
}
